import React from 'react';
import { FaFacebookSquare, FaInstagramSquare, FaTwitterSquare } from 'react-icons/fa';
import guid1 from '../../images/gettyimages-855413388-612x612.jpg';
import guid2 from '../../images/male-tourist-backpack-walking-isolated-white-background-35845436.jpg';
import guid3 from '../../images/male-tourist-backpack-waving-his-hand-isolated-white-background-35845466.jpg';

const Guide = () => {
    return (
        <div className="my-3">
            <h1 className="fw-bolder">OUR TOUR GUIDE</h1>

            <div className="row row-cols-1 row-cols-md-3 g-4">
                <div className="col ">
                    <div className="card shadow h-100">
                        <img style={{ width: '100%' }} src={guid1} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h3 className="card-title">Sony Madison</h3>
                            <h5 className="card-title">Travel Guide</h5>
                            <div className='d-flex justify-content-evenly px-5 fs-3'>
                                <FaFacebookSquare />
                                <FaTwitterSquare></FaTwitterSquare>
                                <FaInstagramSquare />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col ">
                    <div className="card shadow h-100">
                        <img style={{ width: '100%' }} src={guid2} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h3 className="card-title">Alison White</h3>
                            <h5 className="card-title">Travel Guide</h5>
                            <div className='d-flex justify-content-evenly px-5 fs-3'>
                                <FaFacebookSquare />
                                <FaTwitterSquare></FaTwitterSquare>
                                <FaInstagramSquare />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col ">
                    <div className="card shadow h-100">
                        <img style={{ width: '100%' }} src={guid3} className="card-img-top" alt="..." />
                        <div className="card-body">
                            <h3 className="card-title">William Hobb</h3>
                            <h5 className="card-title">Travel Guide</h5>
                            <div className='d-flex justify-content-evenly px-5 fs-3'>
                                <FaFacebookSquare />
                                <FaTwitterSquare></FaTwitterSquare>
                                <FaInstagramSquare />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Guide;